module.exports = {
  home: [
    {
      id: 1,
      name: 'Sicily',
      image: 'https://www.thethinkingtraveller.com/media/Destinations/Trending/Sicily_trending.jpg',
      linkId: 26,
      linkType: 'page',
    },
    {
      id: 2,
      name: 'Puglia',
      image: 'https://www.thethinkingtraveller.com/media/Destinations/Trending/Puglia_trending.jpg',
      linkId: 28,
      linkType: 'page',
    },
    {
      id: 3,
      name: 'Corsica',
      image: 'https://www.thethinkingtraveller.com/media/Destinations/Trending/Corsica_trending.jpg',
      linkId: 30,
      linkType: 'page',
    },
    {
      id: 4,
      name: 'Corfu',
      image: 'https://www.thethinkingtraveller.com/media/Destinations/Trending/Corfu_trending.jpg',
      linkId: 97,
      linkType: 'page',
    },
    {
      id: 5,
      name: 'Paros',
      image: 'https://www.thethinkingtraveller.com/media/Destinations/Trending/Paros_trending.jpg',
      linkId: 1120,
      linkType: 'page',
    },
    {
      id: 6,
      name: 'Hydra',
      image: 'https://www.thethinkingtraveller.com/media/Destinations/Trending/Hydra_trending.jpg',
      linkId: 1116,
      linkType: 'page',
    },
  ],
  greece: [
    {
      id: 1,
      name: 'Mykonos',
      image: 'https://www.thethinkingtraveller.com/media/Destinations/Trending/Mykonos_trending.jpg',
      linkId: 1121,
      linkType: 'page',
    },
    {
      id: 2,
      name: 'Zakynthos',
      image: 'https://www.thethinkingtraveller.com/media/Destinations/Trending/Zakynthos_trending.jpg',
      linkId: 994,
      linkType: 'page',
    },
    {
      id: 3,
      name: 'Lefkada',
      image: 'https://www.thethinkingtraveller.com/media/Destinations/Trending/Lefkada_trending.jpg',
      linkId: 101,
      linkType: 'page',
    },
    {
      id: 4,
      name: 'Paxos',
      image: 'https://www.thethinkingtraveller.com/media/Destinations/Trending/Paxos_Antipaxos_trending.jpg',
      linkId: 98,
      linkType: 'page',
    },
    {
      id: 5,
      name: 'Tinos',
      image: 'https://www.thethinkingtraveller.com/media/Destinations/Trending/Tinos_trending.jpg',
      linkId: 1123,
      linkType: 'page',
    },
    {
      id: 6,
      name: 'Patmos',
      image: 'https://www.thethinkingtraveller.com/media/Destinations/Trending/Patmos_trending.jpg',
      linkId: 1210,
      linkType: 'page',
    },
  ],
};
